import React from 'react';
import { View, Image, StyleSheet } from 'react-native';

import { useDispatch } from 'react-redux';

import { CommonStyles, CommonProperties, Color, FontSize } from '../../styles';
import { Screens } from '../../constants/ScreenNames';
import { userTypes } from '../../constants/Enums';
import { useNavigation } from '@react-navigation/native';
import { scale } from '../../utils/scale.utils';
import { selectTrip } from '../../store/actions/mytrips';
import RowView from '../RowView';
import BaseText from '../BaseText';
import Button from '../Button';

const ConnectionRequest = ({ trip, type }) => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  return (
    <View style={CommonStyles.boxShadow}>
      <View style={styles.topContainer}>
        <RowView>
          <Image source={{ uri: 'https://picsum.photos/80' }} style={styles.smallImage} />
          <View style={styles.cardHeading}>
            <BaseText style={styles.mediumText}>TripEasy</BaseText>
            <BaseText style={CommonStyles.h4}>Connection Requested</BaseText>
          </View>
          <BaseText style={styles.mediumText}>2h</BaseText>
        </RowView>
      </View>
      <View style={styles.cardContent}>
        <RowView style={styles.messageContainer}>
          <View style={CommonStyles.flex1}>
            <Image source={{ uri: 'https://picsum.photos/80' }} style={styles.messageImage} />
          </View>
          <View style={styles.messageBody}>
            <BaseText style={styles.messageText}>New Connection Request</BaseText>
            <BaseText>Robert Newman</BaseText>
            <BaseText style={styles.requestText}>
              Robert is on Tripeasy. Do you want to Accept this connection request?
            </BaseText>
          </View>
        </RowView>
      </View>
      {type == 'Connection' && (
        <View style={styles.requestContainer}>
          <Button
            label={'Accept'}
            style={styles.buttonText}
            labelStyle={styles.labeltext}
            onPress={() => {
              dispatch(selectTrip(trip));
              navigation.navigate(Screens.TripHub, {
                userType: userTypes.VISITOR,
              });
            }}
          />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  topContainer: {
    justifyContent: 'space-between',
    ...CommonProperties.p3,
    ...CommonProperties.mx5,
    ...CommonProperties.mt5,
    borderTopLeftRadius: scale(6),
    borderTopRightRadius: scale(6),
  },
  smallImage: {
    height: 44,
    width: 44,
    borderRadius: 22,
  },
  mediumText: {
    color: Color.text.medium,
  },
  cardHeading: {
    flex: 1,
    ...CommonProperties.pl3,
  },
  cardContent: {
    backgroundColor: '#F6F6F6',
    ...CommonProperties.py5,
    alignItems: 'center',
  },
  messageContainer: {
    backgroundColor: Color.accent,
    width: '85%',
    borderRadius: 45,
  },
  messageImage: {
    height: 70,
    width: 70,
    borderRadius: 40,
    ...CommonProperties.m2,
  },
  messageBody: {
    flex: 4,
    ...CommonProperties.ml4,
    ...CommonProperties.px5,
    ...CommonProperties.py3,
  },
  requestText: {
    fontSize: FontSize.xxSmall,
    fontWeight: 'bold',
  },
  messageText: {
    color: Color.text.medium,
    fontSize: FontSize.xSmall,
  },
  requestContainer: {
    ...CommonProperties.p3,
    ...CommonProperties.mx5,
    borderBottomLeftRadius: scale(6),
    borderBottomRightRadius: scale(6),
  },
  buttonText: {
    ...CommonProperties.borderRadius4,
    ...CommonProperties.py2,
  },
  labeltext: {
    ...CommonProperties.h3,
  },
});

export default ConnectionRequest;
